import "./about.css";
import React, { useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import MyImage from "../../../src/images/myprofilepic1.jpg";

const About = ({ setActive, user }) => {
  useEffect(() => {
    document.title = "About Me - youvaraj.com";
  }, []);

  return (
    <Container className="my-container">
      <Row className="about-row">
        <Col lg={8} md={12} className="about-content-col">
          <div className="containerAbout">
            <h1 className="about-title">About Me</h1>

            <div className="about-text">
              <p>
                I'm a curious soul, and when I meet someone who shares my
                interests, I genuinely enjoy their company and our conversations
                flow naturally. I value experiences over opinions and believe
                life is too short to follow the crowd. Why rely on someone
                else's recommendation when I can explore, taste, and decide for
                myself?
              </p>

              <p>
                I believe the truly important things in life are free—fresh air
                to breathe, water to drink, a place to call home. That
                perspective shapes how I live: I don't chase trends, waste time
                on meaningless showmanship, or follow what everyone else is
                doing.
              </p>

              <p>
                When I do spend my spare time, it's on things that nourish my
                mind and soul rather than impress others. I enjoy learning
                musical instruments—not to perform or show off, but to destress,
                appreciate music, and grow as a person.
              </p>

              <p>
                I also believe there are certain life skills everyone should try
                at least once: riding a bicycle, swimming, learning to drive a
                manual motorcycle, or playing a musical instrument. These are
                not just hobbies—they're experiences that make life richer, more
                complete, and more memorable.
              </p>

              <p className="about-closing">
                Simply put, I live to explore, learn, and experience life on my
                own terms.
              </p>
            </div>
          </div>
        </Col>
        <Col lg={4} md={12} className="about-image-col">
          <div className="containerAboutImage">
            <div className="circle-image-container">
              <img
                src={MyImage}
                alt={"Youvaraj Acharya"}
                className="circle-image"
              />
            </div>
            <div className="image-caption">
              <h3>Youvaraj Acharya</h3>
              <p>Explorer • Learner • Music lover</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
